function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeTyping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-1"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.65,
    y: 264.19,
    width: 27.72,
    height: 27.72,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.69,
    y: 268.2,
    width: 33.64,
    height: 19.42,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.24,
    y: 252.04,
    width: 14.54,
    height: 8.94,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.17,
    y: 253.92,
    width: 18.68,
    height: 4.79,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.26,
    y: 264.19,
    width: 3.75,
    height: 3.75,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.12,
    y: 253.92,
    width: 3.02,
    height: 10.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.18,
    y: 275.62,
    width: 3.83,
    height: 3.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.01,
    y: 271.66,
    width: 3.96,
    height: 3.96,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.97,
    y: 266.07,
    width: 3.87,
    height: 5.59,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.01,
    y: 264.19,
    width: 3.75,
    height: 3.75,
    transform: "translate(765.77 532.14) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.87,
    y: 253.92,
    width: 3.02,
    height: 10.27,
    transform: "translate(758.77 518.12) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.01,
    y: 275.62,
    width: 3.83,
    height: 3.83,
    transform: "translate(765.85 555.07) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.05,
    y: 271.66,
    width: 3.96,
    height: 3.96,
    transform: "translate(758.06 547.29) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.18,
    y: 266.07,
    width: 3.87,
    height: 5.59,
    transform: "translate(750.24 537.74) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 291.76,
    width: 3.75,
    height: 3.75,
    transform: "translate(771.75 587.27) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.86,
    y: 295.51,
    width: 3.02,
    height: 10.27,
    transform: "translate(764.75 601.3) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.97,
    y: 281.66,
    width: 3.83,
    height: 3.83,
    transform: "translate(765.77 567.15) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.02,
    y: 285.49,
    width: 3.96,
    height: 3.96,
    transform: "translate(757.99 574.93) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.15,
    y: 289.44,
    width: 3.87,
    height: 5.59,
    transform: "translate(750.17 584.48) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.34,
    y: 291.76,
    width: 3.75,
    height: 3.75,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.2,
    y: 295.51,
    width: 3.02,
    height: 10.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.15,
    y: 281.66,
    width: 3.83,
    height: 3.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.97,
    y: 285.49,
    width: 3.96,
    height: 3.96,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426,
    y: 289.44,
    width: 3.87,
    height: 5.59,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.98,
    y: 158.25,
    width: 27.72,
    height: 27.72,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.03,
    y: 162.25,
    width: 33.64,
    height: 19.42,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.57,
    y: 146.09,
    width: 14.54,
    height: 8.94,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.5,
    y: 147.98,
    width: 18.68,
    height: 4.79,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.59,
    y: 158.25,
    width: 3.75,
    height: 3.75,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.46,
    y: 147.98,
    width: 3.02,
    height: 10.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.52,
    y: 169.68,
    width: 3.83,
    height: 3.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.34,
    y: 165.72,
    width: 3.96,
    height: 3.96,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.3,
    y: 160.13,
    width: 3.87,
    height: 5.59,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.34,
    y: 158.25,
    width: 3.75,
    height: 3.75,
    transform: "translate(434.44 320.25) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.21,
    y: 147.98,
    width: 3.02,
    height: 10.27,
    transform: "translate(427.44 306.23) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.34,
    y: 169.68,
    width: 3.83,
    height: 3.83,
    transform: "translate(434.51 343.18) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.39,
    y: 165.72,
    width: 3.96,
    height: 3.96,
    transform: "translate(426.73 335.4) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.52,
    y: 160.13,
    width: 3.87,
    height: 5.59,
    transform: "translate(418.91 325.85) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.33,
    y: 185.82,
    width: 3.75,
    height: 3.75,
    transform: "translate(440.42 375.38) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.19,
    y: 189.57,
    width: 3.02,
    height: 10.27,
    transform: "translate(433.41 389.41) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.31,
    y: 175.72,
    width: 3.83,
    height: 3.83,
    transform: "translate(434.44 355.26) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.35,
    y: 179.54,
    width: 3.96,
    height: 3.96,
    transform: "translate(426.66 363.04) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.48,
    y: 183.5,
    width: 3.87,
    height: 5.59,
    transform: "translate(418.83 372.59) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.67,
    y: 185.82,
    width: 3.75,
    height: 3.75,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.54,
    y: 189.57,
    width: 3.02,
    height: 10.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.48,
    y: 175.72,
    width: 3.83,
    height: 3.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.31,
    y: 179.54,
    width: 3.96,
    height: 3.96,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.34,
    y: 183.5,
    width: 3.87,
    height: 5.59,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.2,
    y: 76.33,
    width: 17.42,
    height: 17.42,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.35,
    y: 78.85,
    width: 21.13,
    height: 12.2,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.34,
    y: 68.7,
    width: 9.13,
    height: 5.62,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.04,
    y: 69.88,
    width: 11.73,
    height: 3.01,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.43,
    y: 76.33,
    width: 2.36,
    height: 2.36,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.86,
    y: 69.88,
    width: 1.9,
    height: 6.45,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.38,
    y: 83.51,
    width: 2.4,
    height: 2.4,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.79,
    y: 81.03,
    width: 2.48,
    height: 2.48,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.27,
    y: 77.51,
    width: 2.43,
    height: 3.51,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.03,
    y: 76.33,
    width: 2.36,
    height: 2.36,
    transform: "translate(440.42 155.02) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.06,
    y: 69.88,
    width: 1.9,
    height: 6.45,
    transform: "translate(436.02 146.21) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.03,
    y: 83.51,
    width: 2.4,
    height: 2.4,
    transform: "translate(440.47 169.42) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.55,
    y: 81.03,
    width: 2.48,
    height: 2.48,
    transform: "translate(435.58 164.54) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.12,
    y: 77.51,
    width: 2.43,
    height: 3.51,
    transform: "translate(430.67 158.54) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.91,
    y: 93.65,
    width: 2.36,
    height: 2.36,
    transform: "translate(444.18 189.65) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.94,
    y: 96.01,
    width: 1.9,
    height: 6.45,
    transform: "translate(439.78 198.46) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.01,
    y: 87.3,
    width: 2.4,
    height: 2.4,
    transform: "translate(440.43 177.01) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.53,
    y: 89.71,
    width: 2.49,
    height: 2.48,
    transform: "translate(435.54 181.9) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.09,
    y: 92.19,
    width: 2.43,
    height: 3.51,
    transform: "translate(430.62 187.9) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.6,
    y: 93.65,
    width: 2.36,
    height: 2.36,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.02,
    y: 96.01,
    width: 1.9,
    height: 6.45,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.36,
    y: 87.3,
    width: 2.4,
    height: 2.4,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.76,
    y: 89.71,
    width: 2.49,
    height: 2.48,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.29,
    y: 92.19,
    width: 2.43,
    height: 3.51,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.03,
    y: 83.97,
    width: 10.81,
    height: 10.81,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.88,
    y: 85.53,
    width: 13.11,
    height: 7.57,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.6,
    y: 79.23,
    width: 5.67,
    height: 3.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.79,
    y: 79.97,
    width: 7.28,
    height: 1.87,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.96,
    y: 83.97,
    width: 1.46,
    height: 1.46,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.47,
    y: 79.97,
    width: 1.18,
    height: 4,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.93,
    y: 88.43,
    width: 1.49,
    height: 1.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.42,
    y: 86.88,
    width: 1.54,
    height: 1.54,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.96,
    y: 84.7,
    width: 1.51,
    height: 2.18,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.44,
    y: 83.97,
    width: 1.46,
    height: 1.46,
    transform: "translate(132.34 169.41) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.22,
    y: 79.97,
    width: 1.18,
    height: 4,
    transform: "translate(129.61 163.94) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.44,
    y: 88.43,
    width: 1.49,
    height: 1.49,
    transform: "translate(132.37 178.34) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.9,
    y: 86.88,
    width: 1.54,
    height: 1.54,
    transform: "translate(129.34 175.31) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.39,
    y: 84.7,
    width: 1.51,
    height: 2.18,
    transform: "translate(126.29 171.59) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.61,
    y: 94.72,
    width: 1.46,
    height: 1.46,
    transform: "translate(134.67 190.89) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.38,
    y: 96.18,
    width: 1.18,
    height: 4,
    transform: "translate(131.94 196.36) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.43,
    y: 90.78,
    width: 1.49,
    height: 1.49,
    transform: "translate(132.34 183.05) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.88,
    y: 92.27,
    width: 1.54,
    height: 1.54,
    transform: "translate(129.31 186.08) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.38,
    y: 93.81,
    width: 1.51,
    height: 2.18,
    transform: "translate(126.26 189.81) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.82,
    y: 94.72,
    width: 1.46,
    height: 1.46,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.33,
    y: 96.18,
    width: 1.18,
    height: 4,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.92,
    y: 90.78,
    width: 1.49,
    height: 1.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.41,
    y: 92.27,
    width: 1.54,
    height: 1.54,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.98,
    y: 93.81,
    width: 1.51,
    height: 2.18,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.56,
    y: 186.21,
    width: 37.24,
    height: 26.48,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.9,
    y: 184.16,
    width: 30.56,
    height: 30.56,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.37,
    y: 175.31,
    width: 4.07,
    height: 7.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.92,
    y: 175.31,
    width: 4.07,
    height: 7.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.44,
    y: 171.29,
    width: 21.47,
    height: 4.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.7,
    y: 193.38,
    width: 8.96,
    height: 6.07,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.57,
    y: 197.25,
    width: 3.21,
    height: 9.32,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.19,
    y: 109.76,
    width: 37.24,
    height: 26.48,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.53,
    y: 107.71,
    width: 30.56,
    height: 30.56,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.01,
    y: 98.86,
    width: 4.07,
    height: 7.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.55,
    y: 98.86,
    width: 4.07,
    height: 7.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.08,
    y: 94.84,
    width: 21.47,
    height: 4.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.33,
    y: 116.93,
    width: 8.96,
    height: 6.07,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.2,
    y: 120.8,
    width: 3.21,
    height: 9.32,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.47,
    y: 324.77,
    width: 37.24,
    height: 26.48,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.81,
    y: 322.72,
    width: 30.56,
    height: 30.56,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.29,
    y: 313.87,
    width: 4.07,
    height: 7.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.83,
    y: 313.87,
    width: 4.07,
    height: 7.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.36,
    y: 309.85,
    width: 21.47,
    height: 4.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.61,
    y: 331.94,
    width: 8.96,
    height: 6.07,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.49,
    y: 335.81,
    width: 3.21,
    height: 9.32,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.91,
    y: 235.28,
    width: 20.23,
    height: 14.38,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.72,
    y: 234.17,
    width: 16.6,
    height: 16.6,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.98,
    y: 229.36,
    width: 2.21,
    height: 3.95,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.85,
    y: 229.36,
    width: 2.21,
    height: 3.95,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.19,
    y: 227.18,
    width: 11.66,
    height: 2.28,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.59,
    y: 239.17,
    width: 4.87,
    height: 3.3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.15,
    y: 241.27,
    width: 1.75,
    height: 5.06,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.06,
    y: 82.43,
    width: 31.32,
    height: 39.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.59,
    y: 84.43,
    width: 44.27,
    height: 21.92,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.17,
    y: 101.73,
    width: 39.1,
    height: 13.71,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.1,
    y: 118.09,
    width: 21.24,
    height: 7.4,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.9,
    y: 123.03,
    width: 5.63,
    height: 6.01,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.32,
    y: 97,
    width: 4.71,
    height: 4.71,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.03,
    y: 101.89,
    width: 4.82,
    height: 4.82,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.86,
    y: 106.72,
    width: 5.82,
    height: 4.31,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.68,
    y: 100.61,
    width: 4.35,
    height: 6.13,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.03,
    y: 95.07,
    width: 4.35,
    height: 5.55,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.38,
    y: 90.45,
    width: 4.74,
    height: 4.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.52,
    y: 93.55,
    width: 19.42,
    height: 24.37,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.5,
    y: 94.79,
    width: 27.45,
    height: 13.59,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.11,
    y: 105.52,
    width: 24.24,
    height: 8.5,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.64,
    y: 115.66,
    width: 13.17,
    height: 4.59,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.48,
    y: 118.72,
    width: 3.49,
    height: 3.73,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.3,
    y: 102.58,
    width: 2.92,
    height: 2.92,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.22,
    y: 105.62,
    width: 2.99,
    height: 2.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.21,
    y: 108.61,
    width: 3.61,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.82,
    y: 104.82,
    width: 2.7,
    height: 3.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.52,
    y: 101.38,
    width: 2.7,
    height: 3.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.22,
    y: 98.52,
    width: 2.94,
    height: 2.94,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.42,
    y: 323.8,
    width: 13.67,
    height: 17.15,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.59,
    y: 324.67,
    width: 19.32,
    height: 9.57,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.72,
    y: 332.22,
    width: 17.06,
    height: 5.98,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.62,
    y: 339.37,
    width: 9.27,
    height: 3.23,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.02,
    y: 341.52,
    width: 2.46,
    height: 2.62,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.97,
    y: 330.16,
    width: 2.06,
    height: 2.06,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.02,
    y: 332.3,
    width: 2.1,
    height: 2.1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.13,
    y: 334.4,
    width: 2.54,
    height: 1.88,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.67,
    y: 331.74,
    width: 1.9,
    height: 2.68,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.57,
    y: 329.32,
    width: 1.9,
    height: 2.42,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.47,
    y: 327.3,
    width: 2.07,
    height: 2.07,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-1",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.18,348.33s6.35-5.29,11.79,0,6.5,38.08,6.5,38.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.92,392.74s-3.74-38.48,10.34-54.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.58,388.68s2.88-43.8-7.69-53.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.92,388.68s.24-28.94,8.09-33.44,11.86,10.18,11.86,10.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.82,388.68s1.28-22.22-4.81-30.16-12.48,3.4-12.48,3.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.94,391.66s-3.94-52,2.57-60.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.74,359.46s-3.92,1.44-2.75,4.85,13.54,9,13.54,9,5.18-4.75.42-12.48S428.84,357,428.74,359.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.74,359.46s-3.92,1.44-2.75,4.85,13.54,9,13.54,9,5.18-4.75.42-12.48S428.84,357,428.74,359.46Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.72,353s4.17-.17,4.4,3.42-9,13.53-9,13.53-6.61-2.39-5.19-11.36S410.68,350.76,411.72,353Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.72,353s4.17-.17,4.4,3.42-9,13.53-9,13.53-6.61-2.39-5.19-11.36S410.68,350.76,411.72,353Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.19,335.77s2.78-.3,2.55-2-10.8-6-17,1c0,0,4,6.86,9.77,7S408.19,335.77,408.19,335.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.19,335.77s2.78-.3,2.55-2-10.8-6-17,1c0,0,4,6.86,9.77,7S408.19,335.77,408.19,335.77Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.37,331.66s-2.52,1.22-3.22-.34,6-10.85,15-8.17c0,0,.24,7.94-4.62,11.07S413.37,331.66,413.37,331.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.37,331.66s-2.52,1.22-3.22-.34,6-10.85,15-8.17c0,0,.24,7.94-4.62,11.07S413.37,331.66,413.37,331.66Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.21,358.09s1.92-1.55-.15-2.31-12.23-.54-12.34,9.52c0,0,11.83,2,13.3-1.86S400.21,358.09,400.21,358.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.21,358.09s1.92-1.55-.15-2.31-12.23-.54-12.34,9.52c0,0,11.83,2,13.3-1.86S400.21,358.09,400.21,358.09Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.33,335.52s-1.92-1.55.16-2.31,12.22-.54,12.33,9.53c0,0-11.83,2-13.3-1.87S424.33,335.52,424.33,335.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.33,335.52s-1.92-1.55.16-2.31,12.22-.54,12.33,9.53c0,0-11.83,2-13.3-1.87S424.33,335.52,424.33,335.52Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.08,343.62s-.17-1.88,1.35-1.14,6.82,6.45,1.33,11.87c0,0-7.39-5.47-6.06-8.32S418.08,343.62,418.08,343.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.08,343.62s-.17-1.88,1.35-1.14,6.82,6.45,1.33,11.87c0,0-7.39-5.47-6.06-8.32S418.08,343.62,418.08,343.62Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.49,346.31s1.15-1.5-.53-1.69-9.2,1.82-7.45,9.33c0,0,9.17-.68,9.56-3.81S398.49,346.31,398.49,346.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.49,346.31s1.15-1.5-.53-1.69-9.2,1.82-7.45,9.33c0,0,9.17-.68,9.56-3.81S398.49,346.31,398.49,346.31Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.47 416.57 398.01 416.57 394.62 382.13 432.86 382.13 429.47 416.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.47 416.57 398.01 416.57 394.62 382.13 432.86 382.13 429.47 416.57",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.94,
    y: 378.33,
    width: 41.61,
    height: 7.6,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.94,
    y: 378.33,
    width: 41.61,
    height: 7.6,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screens--inject-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336.25,
    y: 140.65,
    width: 111.53,
    height: 91.74,
    rx: 2.29,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.78,142.94V230.1a2.29,2.29,0,0,1-2.29,2.29H338.54a2.29,2.29,0,0,1-2.29-2.29V142.94a2.3,2.3,0,0,1,2.29-2.29h107A2.3,2.3,0,0,1,447.78,142.94Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.62,
    y: 149.98,
    width: 106.78,
    height: 79.84,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.31,159.93a.75.75,0,0,0,.45.14.73.73,0,0,0,.6-.3.74.74,0,0,0-.16-1.05L346,157.09l2.21-1.63a.75.75,0,1,0-.89-1.21l-3,2.24a.76.76,0,0,0,0,1.21Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.47,157.08l-2.21,1.64a.73.73,0,0,0-.16,1,.75.75,0,0,0,.6.31.76.76,0,0,0,.45-.15l3-2.24a.74.74,0,0,0,0-1.2l-3-2.23a.75.75,0,1,0-.89,1.2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.69,160a.69.69,0,0,0,.25,0,.73.73,0,0,0,.7-.5l1.59-4.47a.75.75,0,1,0-1.42-.5l-1.58,4.47A.75.75,0,0,0,350.69,160Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.2,160.32h3.95a1,1,0,0,0,0-2H363.2a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.25,216.89H365.38a1,1,0,0,0,0,2h61.87a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.84,216.89h-7.65a1,1,0,1,0,0,2h7.65a1,1,0,1,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,212.56h24.91a1,1,0,0,0,0-2H384a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.25,212.56a1,1,0,0,0,0-2H413.12a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.84,210.56h-7.51a1,1,0,0,0,0,2h7.51a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.35,204.23H394a1,1,0,0,0,0,2h33.32a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.84,204.23h-7.6a1,1,0,0,0,0,2h7.6a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,198.9a1,1,0,0,0-1-1H374a1,1,0,0,0,0,2h34A1,1,0,0,0,409,198.9Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.16,197.9a1,1,0,0,0,0,2h13.18a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.84,197.9h-7.51a1,1,0,0,0,0,2h7.51a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,193.57h6.54a1,1,0,0,0,0-2H416a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.22,193.57h13.62a1,1,0,0,0,0-2H427.22a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.35,186.24a1,1,0,0,0-1-1H344a1,1,0,0,0,0,2h34.32A1,1,0,0,0,379.35,186.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.75,187.24h10.09a1,1,0,0,0,0-2H383.75a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,180.91h13a1,1,0,0,0,0-2H344a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.84,179.91a1,1,0,0,0-1-1H363.48a1,1,0,0,0,0,2h40.36A1,1,0,0,0,404.84,179.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,174.58h23.55a1,1,0,0,0,0-2H344a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,173.58a1,1,0,0,0,1,1h5.83a1,1,0,0,0,0-2H373A1,1,0,0,0,372,173.58Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,168.25h27.81a1,1,0,0,0,0-2H344a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.51,168.25h21.33a1,1,0,0,0,0-2H392.51a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.14,140.65v24.86a5,5,0,0,1-5,5H336.25V142.94a2.3,2.3,0,0,1,2.29-2.29Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.33,
    y: 70.87,
    width: 125.53,
    height: 91.74,
    rx: 2.29,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.86,73.16v87.16a2.29,2.29,0,0,1-2.29,2.29H271.62a2.28,2.28,0,0,1-2.29-2.29V73.16a2.29,2.29,0,0,1,2.29-2.29h121A2.3,2.3,0,0,1,394.86,73.16Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.7,
    y: 80.2,
    width: 120.78,
    height: 79.84,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.39,90.15a.75.75,0,0,0,.45.14.75.75,0,0,0,.44-1.35l-2.21-1.63,2.21-1.63a.75.75,0,0,0-.89-1.21l-3,2.24a.76.76,0,0,0,0,1.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.54,87.3l-2.2,1.64a.73.73,0,0,0-.16,1,.75.75,0,0,0,.6.31.76.76,0,0,0,.45-.15l3-2.24a.72.72,0,0,0,.31-.6.75.75,0,0,0-.31-.6l-3-2.23a.75.75,0,1,0-.89,1.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.77,90.25a.69.69,0,0,0,.25,0,.74.74,0,0,0,.7-.5l1.58-4.47a.73.73,0,0,0-.45-.95.75.75,0,0,0-1,.45l-1.58,4.47A.75.75,0,0,0,283.77,90.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.27,90.54h4a1,1,0,0,0,0-2h-4a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.58,98.47h5.34a1,1,0,0,0,0-2h-5.34a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.7,97.47a1,1,0,0,0,1,1h50a1,1,0,0,0,0-2h-50A1,1,0,0,0,289.7,97.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.11,98.47h7.65a1,1,0,0,0,0-2h-7.65a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.92,104.8a1,1,0,0,0,0-2H309a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.7,104.8h14.13a1,1,0,0,0,0-2H290.7a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.11,104.8h7.52a1,1,0,0,0,0-2h-7.52a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.92,110.13a1,1,0,0,0-1-1H290.6a1,1,0,0,0,0,2h28.32A1,1,0,0,0,319.92,110.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.11,111.13h7.6a1,1,0,0,0,0-2h-7.6a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,117.46h29a1,1,0,0,0,0-2H310a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.62,115.46a1,1,0,0,0,0,2h13.17a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.11,117.46h7.51a1,1,0,0,0,0-2h-7.51a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.92,121.79h-6.53a1,1,0,0,0,0,2h6.53a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.73,121.79H277.11a1,1,0,0,0,0,2h13.62a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.6,129.12a1,1,0,0,0,1,1h53.32a1,1,0,0,0,0-2H334.6A1,1,0,0,0,333.6,129.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.11,128.12a1,1,0,0,0,0,2H329.2a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.92,134.45h-13a1,1,0,0,0,0,2h13a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.48,135.45a1,1,0,0,0-1-1H314.11a1,1,0,0,0,0,2h54.37A1,1,0,0,0,369.48,135.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.92,140.78H364.37a1,1,0,0,0,0,2h23.55a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.11,140.78a1,1,0,0,0,0,2H359a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.92,147.11H341.11a1,1,0,0,0,0,2h46.81a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.45,147.11H304.11a1,1,0,0,0,0,2h16.34a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.25,110.35v52.26H271.62a2.28,2.28,0,0,1-2.29-2.29V105.9H331.8A4.45,4.45,0,0,1,336.25,110.35Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.47,
    y: 109.77,
    width: 144.53,
    height: 91.74,
    rx: 2.29,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.47,
    y: 109.77,
    width: 144.53,
    height: 91.74,
    rx: 2.29,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.85,
    y: 119.09,
    width: 139.78,
    height: 79.84,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.62,135.85H191.25a1,1,0,0,0,0,2h22.37a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.62,142.09H194.25a1,1,0,0,0,0,2h19.37a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.62,148.33H191.25a1,1,0,0,0,0,2h22.37a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.62,154.57H200.25a1,1,0,0,0,0,2h13.37a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.62,160.81H191.25a1,1,0,0,0,0,2h22.37a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.62,167.05H195.25a1,1,0,0,0,0,2h18.37a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.62,173.29H195.25a1,1,0,0,0,0,2h18.37a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.62,179.53H193.25a1,1,0,0,0,0,2h20.37a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.62,185.77H200.25a1,1,0,0,0,0,2h13.37a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.62,129.61H197.25a1,1,0,0,0,0,2h16.37a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.62,123.37H191.25a1,1,0,0,0,0,2h22.37a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.62,192H191.25a1,1,0,0,0,0,2h22.37a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.25,
    y: 135.6,
    width: 4.37,
    height: 2.5,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.25,
    y: 141.84,
    width: 4.37,
    height: 2.5,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.25,
    y: 148.08,
    width: 4.37,
    height: 2.5,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.25,
    y: 154.32,
    width: 4.37,
    height: 2.5,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.25,
    y: 160.56,
    width: 4.37,
    height: 2.5,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.25,
    y: 166.8,
    width: 4.37,
    height: 2.5,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.25,
    y: 173.04,
    width: 4.37,
    height: 2.5,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.25,
    y: 179.28,
    width: 4.37,
    height: 2.5,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.25,
    y: 185.52,
    width: 4.37,
    height: 2.5,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.25,
    y: 129.36,
    width: 4.37,
    height: 2.5,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.25,
    y: 123.12,
    width: 4.37,
    height: 2.5,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.25,
    y: 191.76,
    width: 4.37,
    height: 2.5,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.25,136.85a1,1,0,0,0,1,1h72.37a1,1,0,0,0,0-2H249.25A1,1,0,0,0,248.25,136.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.62,142.09H282a1,1,0,0,0,0,2h39.63a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.58,142.09H260.25a1,1,0,0,0,0,2h12.33a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.62,148.33h-55a1,1,0,0,0,0,2h55a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.25,150.33h3.9a1,1,0,0,0,0-2h-3.9a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.62,155.57a1,1,0,0,0-1-1h-51a1,1,0,0,0,0,2h51A1,1,0,0,0,304.62,155.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.25,156.57h14.39a1,1,0,0,0,0-2H231.25a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.25,162.81h54.37a1,1,0,0,0,0-2H231.25a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.42,167.05a1,1,0,0,0,0,2h28.2a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.25,169.05h24.41a1,1,0,1,0,0-2H231.25a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.62,173.29H255.25a1,1,0,0,0,0,2h66.37a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.62,179.53H264.25a1,1,0,0,0,0,2h57.37a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.62,185.77h-11.8a1,1,0,0,0,0,2h11.8a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.57,185.77H258.25a1,1,0,0,0,0,2h43.32a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.25,131.61h46.37a1,1,0,0,0,0-2H231.25a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.25,125.37h72.37a1,1,0,0,0,0-2H231.25a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.62,192H267.9a1,1,0,0,0,0,2h30.72a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.19,192H231.25a1,1,0,0,0,0,2h27.94a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.91,131.61a1,1,0,0,0,0-2h-3.6a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.08,136.85a1,1,0,0,0-1-1h-4.83a1,1,0,0,0,0,2h4.83A1,1,0,0,0,244.08,136.85Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.22,161.81a1,1,0,0,0-1-1h-5.28a1,1,0,0,0,0,2h5.28A1,1,0,0,0,299.22,161.81Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.53,156.57a1,1,0,0,0,0-2h-4.29a1,1,0,0,0,0,2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.21,173.29a1,1,0,0,0,0,2h4.31a1,1,0,0,0,0-2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.13,
    y: 159.01,
    width: 39.87,
    height: 24.69,
    rx: 3.4,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.11,182.45s1.51,6.89,10.31,9.56c0,0-4.58-4.14-3.55-9.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.34,162.9v4.15h-.43v-3.77h-1v-.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.32,165c0-1.32.7-2.1,1.66-2.1s1.65.78,1.65,2.1-.69,2.11-1.65,2.11S109.32,166.29,109.32,165Zm2.88,0c0-1.1-.5-1.71-1.22-1.71s-1.22.61-1.22,1.71.49,1.72,1.22,1.72S112.2,166.08,112.2,165Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.24,165c0-1.32.69-2.1,1.65-2.1s1.66.78,1.66,2.1-.7,2.11-1.66,2.11S113.24,166.29,113.24,165Zm2.87,0c0-1.1-.49-1.71-1.22-1.71s-1.22.61-1.22,1.71.5,1.72,1.22,1.72S116.11,166.08,116.11,165Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.3,162.9v4.15h-.43v-3.77h-1v-.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.43,162.9v4.15H120v-3.77h-1v-.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.42,165c0-1.32.69-2.1,1.65-2.1s1.66.78,1.66,2.1-.7,2.11-1.66,2.11S121.42,166.29,121.42,165Zm2.87,0c0-1.1-.5-1.71-1.22-1.71s-1.22.61-1.22,1.71.5,1.72,1.22,1.72S124.29,166.08,124.29,165Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.48,162.9v4.15h-.43v-3.77h-1v-.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.46,165c0-1.32.7-2.1,1.65-2.1s1.66.78,1.66,2.1-.7,2.11-1.66,2.11S127.46,166.29,127.46,165Zm2.87,0c0-1.1-.49-1.71-1.22-1.71s-1.21.61-1.21,1.71.49,1.72,1.21,1.72S130.33,166.08,130.33,165Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.38,165c0-1.32.69-2.1,1.65-2.1s1.66.78,1.66,2.1-.7,2.11-1.66,2.11S131.38,166.29,131.38,165Zm2.87,0c0-1.1-.5-1.71-1.22-1.71s-1.22.61-1.22,1.71.5,1.72,1.22,1.72S134.25,166.08,134.25,165Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.44,162.9v4.15H136v-3.77h-1v-.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.57,162.9v4.15h-.42v-3.77h-1v-.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.19,171c0-1.32.69-2.1,1.65-2.1s1.66.78,1.66,2.1-.7,2.11-1.66,2.11S107.19,172.29,107.19,171Zm2.87,0c0-1.1-.5-1.71-1.22-1.71s-1.22.61-1.22,1.71.5,1.72,1.22,1.72S110.06,172.08,110.06,171Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.11,171c0-1.32.69-2.1,1.65-2.1s1.65.78,1.65,2.1-.69,2.11-1.65,2.11S111.11,172.29,111.11,171Zm2.87,0c0-1.1-.5-1.71-1.22-1.71s-1.22.61-1.22,1.71.5,1.72,1.22,1.72S114,172.08,114,171Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.16,168.9v4.15h-.43v-3.77h-1v-.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.3,168.9v4.15h-.43v-3.77h-1v-.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.28,171c0-1.32.7-2.1,1.66-2.1s1.65.78,1.65,2.1-.69,2.11-1.65,2.11S119.28,172.29,119.28,171Zm2.88,0c0-1.1-.5-1.71-1.22-1.71s-1.22.61-1.22,1.71.49,1.72,1.22,1.72S122.16,172.08,122.16,171Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.34,168.9v4.15h-.43v-3.77h-1v-.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.33,171c0-1.32.69-2.1,1.65-2.1s1.66.78,1.66,2.1-.7,2.11-1.66,2.11S125.33,172.29,125.33,171Zm2.87,0c0-1.1-.5-1.71-1.22-1.71s-1.22.61-1.22,1.71.5,1.72,1.22,1.72S128.2,172.08,128.2,171Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.24,171c0-1.32.7-2.1,1.66-2.1s1.65.78,1.65,2.1-.7,2.11-1.65,2.11S129.24,172.29,129.24,171Zm2.88,0c0-1.1-.5-1.71-1.22-1.71s-1.22.61-1.22,1.71.49,1.72,1.22,1.72S132.12,172.08,132.12,171Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.3,168.9v4.15h-.43v-3.77h-1v-.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.44,168.9v4.15H136v-3.77h-1v-.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.57,168.9v4.15h-.42v-3.77h-1v-.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.34,174.9v4.15h-.43v-3.77h-1v-.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.47,174.9v4.15h-.42v-3.77h-1v-.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.46,177c0-1.32.69-2.1,1.65-2.1s1.66.78,1.66,2.1-.7,2.11-1.66,2.11S111.46,178.29,111.46,177Zm2.87,0c0-1.1-.49-1.71-1.22-1.71s-1.22.61-1.22,1.71.5,1.72,1.22,1.72S114.33,178.08,114.33,177Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.38,177c0-1.32.69-2.1,1.65-2.1s1.66.78,1.66,2.1-.7,2.11-1.66,2.11S115.38,178.29,115.38,177Zm2.87,0c0-1.1-.5-1.71-1.22-1.71s-1.22.61-1.22,1.71.5,1.72,1.22,1.72S118.25,178.08,118.25,177Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.43,174.9v4.15H120v-3.77h-1v-.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.57,174.9v4.15h-.43v-3.77h-1v-.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.56,177c0-1.32.69-2.1,1.65-2.1s1.66.78,1.66,2.1-.7,2.11-1.66,2.11S123.56,178.29,123.56,177Zm2.87,0c0-1.1-.5-1.71-1.22-1.71S124,175.87,124,177s.5,1.72,1.22,1.72S126.43,178.08,126.43,177Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.47,177c0-1.32.7-2.1,1.66-2.1s1.65.78,1.65,2.1-.69,2.11-1.65,2.11S127.47,178.29,127.47,177Zm2.88,0c0-1.1-.5-1.71-1.22-1.71s-1.22.61-1.22,1.71.49,1.72,1.22,1.72S130.35,178.08,130.35,177Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.53,174.9v4.15h-.43v-3.77h-1v-.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.52,177c0-1.32.69-2.1,1.65-2.1s1.66.78,1.66,2.1-.7,2.11-1.66,2.11S133.52,178.29,133.52,177Zm2.87,0c0-1.1-.5-1.71-1.22-1.71S134,175.87,134,177s.5,1.72,1.22,1.72S136.39,178.08,136.39,177Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.57,174.9v4.15h-.42v-3.77h-1v-.38Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.23,394.86l27.5-2.7V353.51h10.9v38.64l27.61,2.71a5.36,5.36,0,0,1,4.84,5.33v4.13H71.4v-4.13A5.36,5.36,0,0,1,76.23,394.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.23,394.86l27.5-2.7V353.51h10.9v38.64l27.61,2.71a5.36,5.36,0,0,1,4.84,5.33v4.13H71.4v-4.13A5.36,5.36,0,0,1,76.23,394.86Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.17,
    cy: 409.45,
    r: 7.13,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.31,
    cy: 409.45,
    r: 7.13,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,327.39h6.39a4.13,4.13,0,0,1,4.13,4.13v30.29a0,0,0,0,1,0,0H101.85a0,0,0,0,1,0,0V331.52A4.13,4.13,0,0,1,106,327.39Z",
    transform: "translate(218.36 689.21) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,327.39h6.39a4.13,4.13,0,0,1,4.13,4.13v30.29a0,0,0,0,1,0,0H101.85a0,0,0,0,1,0,0V331.52A4.13,4.13,0,0,1,106,327.39Z",
    transform: "translate(218.36 689.21) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.12,267S81,318.52,95.39,327.39H79S66.32,309.83,69.9,267Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.12,267S81,318.52,95.39,327.39H79S66.32,309.83,69.9,267Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.43,320.18h63.42a5,5,0,0,1,5,5v6.16a0,0,0,0,1,0,0H73.43a0,0,0,0,1,0,0v-6.16A5,5,0,0,1,78.43,320.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.37,
    y: 325.76,
    width: 79.55,
    height: 5.58,
    rx: 2.01,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.37,
    y: 325.76,
    width: 79.55,
    height: 5.58,
    rx: 2.01,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.97,
    y: 239.34,
    width: 54.09,
    height: 38.11,
    rx: 14.58,
    transform: "translate(158.02 516.79) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "138.13 409.35 146.1 408.26 147.2 389.32 139.25 390.43 138.13 409.35",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.25 390.43 147.2 389.33 146.57 400.16 138.63 400.85 139.25 390.43",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.45,298l-1.94-12.17-44.66-2.67s-4.75,25.33-1.1,32.08c6.51,12.05,41.62,6,51.89,7.16-6.14,25.11-5.54,74.18-5.54,74.18l14.67,1.12s11.29-52.88,13.57-78C166.88,302.77,152.83,303.2,138.45,298Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.38 397.3 153.01 398.46 154.52 390.91 135.15 390.01 135.38 397.3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.51 402.28 164.53 402.87 169.55 384.58 161.54 384 156.51 402.28",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.64,403.23s0,0,0,.06h.06a10.07,10.07,0,0,0,2,.84,2.2,2.2,0,0,0,1.56,0,1,1,0,0,0,.5-.95.73.73,0,0,0-.27-.63,3.24,3.24,0,0,0-2.25-.06,2.89,2.89,0,0,0,1.18-1.63.69.69,0,0,0-.48-.72.92.92,0,0,0-.81,0c-1,.54-1.35,2.78-1.38,2.9h0l-.14,0A.24.24,0,0,0,165.64,403.23Zm.6-.45-.18.06c.19-.74.59-1.95,1.18-2.26a.54.54,0,0,1,.43-.06l.08,0c.25.1.29.25.27.36C168,401.45,167,402.35,166.24,402.78Zm0,.42c1.06-.32,2.53-.61,3-.27a.34.34,0,0,1,.13.3.67.67,0,0,1-.31.61C168.61,404.09,167.58,403.85,166.27,403.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.54 384 169.55 384.59 166.68 395.04 158.76 394.07 161.54 384",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.27,393.75l-14.12-4.15s8.43-47.58,17-64.08c-.64-.21-1.49-.48-2.54-.79-1.89-.57-4.4-1.28-7.35-2.1-20.52-5.69-62.11-16.36-62.11-16.36l19-17.73s75.68,11.54,77.25,31.48C200.13,329.61,172.27,393.75,172.27,393.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.33 389.92 173.33 394.72 176.38 387.65 157.62 382.74 156.33 389.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.59,324.73c-1.89-.57-4.4-1.28-7.35-2.1.59-4.84.6-10.39-1.73-13.22-4.63-5.64-16.54-9-23.32-10.15-5.67-1-24.72-3-24.72-3s24.72-2.37,50,5C178,304.92,175.52,317.13,172.59,324.73Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.38 397.3 153.01 398.46 154.52 390.91 135.15 390.01 135.38 397.3",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.33 389.92 173.33 394.72 176.38 387.65 157.62 382.74 156.33 389.92",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.32,402.06l-8.69-2.43a.58.58,0,0,0-.72.37h0l-2.34,6.76a1.41,1.41,0,0,0,1,1.74c3,.8,4.53,1,8.36,2.06a75.7,75.7,0,0,0,10.28,2.54c3.35.38,3.63-2.94,2.25-3.4-3.28-1.1-7.2-4.51-8.91-6.84A2.27,2.27,0,0,0,165.32,402.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.89,408.28s.17,0,.17,0,.18.06.2.08,0,0,0,.05h.07a9.91,9.91,0,0,0,2.09.41,2.12,2.12,0,0,0,1.53-.3,1,1,0,0,0,.29-1,.73.73,0,0,0-.4-.56,3.33,3.33,0,0,0-2.23.41,2.86,2.86,0,0,0,.79-1.83.75.75,0,0,0-.68-.61,1.16,1.16,0,0,0-.89.21c-.84.72-1,3-1,3.13h0Zm.87-.46-.17.09a4,4,0,0,1,.68-2.46.52.52,0,0,1,.41-.14h.09c.26.05.33.18.34.29A3.86,3.86,0,0,1,147.76,407.82Zm.11.39c1-.53,2.34-1.12,2.86-.88a.32.32,0,0,1,.19.27.69.69,0,0,1-.17.66C150.34,408.61,149.29,408.59,147.87,408.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.7,407.3l-9-.56a.57.57,0,0,0-.63.5h0l-.88,7.1a1.42,1.42,0,0,0,1.31,1.51c3.14.14,4.65.05,8.61.27a74.65,74.65,0,0,0,10.58.34c3.35-.33,2.94-3.63,1.5-3.79-3.44-.39-8-2.92-10.14-4.83A2.25,2.25,0,0,0,146.7,407.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.66,252.57s2.52,13.66,7.06,16.29,35.94-16.13,35.94-16.13l-2.63-5.3s-26.29,7.1-26.54,7.14-1-6-1-6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.46,231.09c2.07,2.56,5,21.48,5,21.48l-15.42,3.59-3.34-9.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.46,231.09c2.07,2.56,5,21.48,5,21.48l-15.42,3.59-3.34-9.58Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.43,298.93l51.75-8.61s3.24-30.74,27.28-59.23c0,0-8.35-18.24-38.05-15.71S87.43,298.93,87.43,298.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.43,298.93l51.75-8.61s3.24-30.74,27.28-59.23c0,0-8.35-18.24-38.05-15.71S87.43,298.93,87.43,298.93Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.71,241.54s-.52,14.22,1.06,15,31.47-10.06,36.21-10.85,15.61,3.36,15.61,3.36l1,6.49s-9.68-.19-15.12-2.84c0,0-34.92,20.88-42.44,19.69S113.93,243,113.93,243Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.71,246.58s.11,8.36,1.85,9,27.6-8.47,27.6-8.47l4.09,9.47s-32.68,21.09-39,15.9-7.91-23.78-7.91-23.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,218.57c9.3-1,5.94,31.93,5.94,31.93l-15.63,2.23S106.62,220.29,123,218.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,218.57c9.3-1,5.94,31.93,5.94,31.93l-15.63,2.23S106.62,220.29,123,218.57Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.75,216.19s-.31,14.46,8.55,15.93,9.79-10.3,9.79-10.3S150.13,215.4,137.75,216.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,224.19a7.14,7.14,0,0,0-4.75,0,6.92,6.92,0,0,1-6.65,5.34,12.08,12.08,0,0,1-2.28-.1c-7.74-1.06-6.89-12.57-6.89-12.57a13.81,13.81,0,0,0,8.06-1.94h0a17.86,17.86,0,0,0,5.28-4.72Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,224.19a7.14,7.14,0,0,0-4.75,0,6.92,6.92,0,0,1-6.65,5.34c-2-4.93-1.73-10.58-1.11-14.61h0a17.86,17.86,0,0,0,5.28-4.72Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,201.84c-3.45,2.34-1.88,6.3,5.92,12.51,3.17-4.11,3.69-12.09,1.18-14.09S169,199.81,166,201.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.19,208.26c.37,8.43.17,13.38,4.34,17.77,6.28,6.61,16.74,2.93,18.89-5.44,1.93-7.52,1-20-7.18-23.53a11.5,11.5,0,0,0-16.05,11.2Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.72,210.79c0,.68.35,1.24.79,1.25s.82-.54.83-1.22-.34-1.25-.78-1.26S163.78,210.11,163.72,210.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.51,210.93c0,.68.34,1.25.79,1.25s.82-.53.84-1.23-.35-1.24-.8-1.25S171.52,210.24,171.51,210.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,211.21a24.08,24.08,0,0,0,3.18,5.91,4,4,0,0,1-3.29.56Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,206.41a.42.42,0,0,1-.37.21,3.19,3.19,0,0,0-2.7,1.09.4.4,0,0,1-.56.08.39.39,0,0,1-.09-.55,4,4,0,0,1,3.39-1.42.39.39,0,0,1,.38.41h0A.37.37,0,0,1,175,206.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,207.92a.41.41,0,0,1-.42-.1,3.19,3.19,0,0,0-2.74-1,.42.42,0,0,1-.48-.32.4.4,0,0,1,.31-.47,4,4,0,0,1,3.48,1.19.42.42,0,0,1,0,.57h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.67,200.86c3.91,1.42,3.36,5.65-2.69,13.57-4.07-3.21-6.54-10.82-4.58-13.37S151.25,199.63,154.67,200.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.07,214.93a8,8,0,0,0,3.73,4.86c2.44,1.38,4.33-.65,4.22-3.3-.11-2.4-1.51-6-4.23-6.3S146.4,212.41,147.07,214.93Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.53,219.08s1.46,2.76,5.54,2.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.526291px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.57,203.79s3.32.17,4.85,2.27a4.69,4.69,0,0,0,.83-3.86s4,.49,5.79,3.27a6.1,6.1,0,0,0,.6-3.27,5.32,5.32,0,0,1,1.21,3.27s3.06-1.94,2.66-3.76a8.54,8.54,0,0,1,1.63,3.16s2-.69,1.57-4.25a6.4,6.4,0,0,1,1.43,2.58s2.62-7.43-7.29-11.58-21.29.77-21.09,9S155.57,203.79,155.57,203.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.07,212.18c0,2.18-1.48,3.95-3.29,3.95s-3.3-1.77-3.3-3.95,1.48-4,3.3-4S168.07,210,168.07,212.18Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.526291px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.08,212c0,2.18-1.47,4-3.29,4s-3.3-1.77-3.3-4,1.48-3.95,3.3-3.95S177.08,209.86,177.08,212Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.526291px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.07,212.18a1.87,1.87,0,0,1,2.42-.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.526291px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.48,
    y1: 212.18,
    x2: 153.46,
    y2: 211.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.526291px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.89,252.57v2.65c0,.79-1.36,1.35-2.15,1.35H172c-.79,0-2.06-.56-2.06-1.35v-2.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.89,252.57v2.65c0,.79-1.36,1.35-2.15,1.35H172c-.79,0-2.06-.56-2.06-1.35v-2.65Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.89,252.57v2.65c0,.79-1.36,1.35-2.15,1.35H193c-.79,0-2.1-.56-2.1-1.35v-2.65Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.8,220.09l-7.35,33.47a2.61,2.61,0,0,1-2.39,2H195.87a1.75,1.75,0,0,1-1.51-2.24l7.35-33.12a2.3,2.3,0,0,1,2.39-1.64h40.18C245.36,218.57,246,219,245.8,220.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.8,220.09l-7.35,33.47a2.61,2.61,0,0,1-2.39,2H195.87a1.75,1.75,0,0,1-1.51-2.24l7.35-33.12a2.3,2.3,0,0,1,2.39-1.64h40.18C245.36,218.57,246,219,245.8,220.09Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.8,220.09l-7.35,33.47a2.61,2.61,0,0,1-2.39,2H197.24a1.75,1.75,0,0,1-1.52-2.24l7.36-33.12a2.3,2.3,0,0,1,2.39-1.64h38.81C245.36,218.57,246,219,245.8,220.09Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.16,241.54c1.87,0,3.79-2,4.28-4.48s-.64-4.49-2.52-4.49a2.91,2.91,0,0,0-1,.2,5.74,5.74,0,0,1-3.19,4.09,1.46,1.46,0,0,0-.05.2C219.15,239.53,220.28,241.54,222.16,241.54Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "271.34 229.07 280.7 238.43 283.87 256.57 264.62 256.57 265.41 254.57 275.96 252.57 276.88 241.54 269.89 239.88 271.34 229.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.87 256.57 264.62 256.57 265.41 254.57 275.96 252.57 276.88 241.54 275.97 241.32 269.89 239.88 271.34 229.07 280.7 238.43 283.87 256.57",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.4 237.13 275.97 241.32 269.89 239.88 271.34 229.07 279.4 237.13",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.25,244.78H259.5a.7.7,0,0,1-.71-.82L265,197.85A1,1,0,0,1,266,197h10.75a.7.7,0,0,1,.72.82L271.19,244A1,1,0,0,1,270.25,244.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.25,244.78H259.5a.7.7,0,0,1-.71-.82L265,197.85A1,1,0,0,1,266,197h10.75a.7.7,0,0,1,.72.82L271.19,244A1,1,0,0,1,270.25,244.78Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.25,244.78H259.5a.7.7,0,0,1-.71-.82L265,197.85A1,1,0,0,1,266,197h7.75a.7.7,0,0,1,.72.82L268.19,244A1,1,0,0,1,267.25,244.78Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.71 243.33 259.46 243.33 265.53 198.48 273.78 198.48 267.71 243.33",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.5 416.57 190.37 416.57 179.36 263.33 187.49 263.33 196.5 416.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.5 416.57 190.37 416.57 179.9 270.94 179.36 263.57 187.49 263.57 187.93 270.94 196.5 416.57",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.93 270.57 179.9 270.57 179.36 263.57 187.49 263.57 187.93 270.57",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.46 416.57 235.33 416.57 234.33 263.33 242.46 263.33 241.46 416.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.46 263.57 242.3 288.3 241.46 416.57 235.33 416.57 234.49 288.3 234.33 263.57 242.46 263.57",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.46 263.57 242.3 288.57 234.49 288.57 234.33 263.57 242.46 263.57",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.5 416.57 300.37 416.57 289.36 263.33 297.49 263.33 306.5 416.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.5 416.57 300.37 416.57 289.9 270.94 289.36 263.57 297.49 263.57 297.93 270.94 306.5 416.57",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.93 270.57 289.9 270.57 289.36 263.57 297.49 263.57 297.93 270.57",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.42 416.57 120.29 416.57 129.29 263.33 137.42 263.33 126.42 416.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.42 263.57 136.88 270.94 126.41 416.57 120.29 416.57 128.85 270.94 129.29 263.57 137.42 263.57",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.29 263.57 137.42 263.57 136.88 270.57 128.85 270.57 129.29 263.57",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.85,259.49H303.93a0,0,0,0,1,0,0V265a2.16,2.16,0,0,1-2.16,2.16H125a2.16,2.16,0,0,1-2.16-2.16v-5.51A0,0,0,0,1,122.85,259.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.85,
    y: 259.49,
    width: 181.08,
    height: 3.84,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.73,260.49H119.06a2.17,2.17,0,0,1-2.17-2.16h0a2.17,2.17,0,0,1,2.17-2.17H307.73a2.17,2.17,0,0,1,2.16,2.17h0A2.16,2.16,0,0,1,307.73,260.49Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeTyping);
export default __webpack_public_path__ + "static/media/CodeTyping.8add5ea9b520f04ab970f3a81e71b613.svg";
export { ForwardRef as ReactComponent };